<div class="field-container">
    <pm-label [LabelWidth]="LabelWidth" [Label]="Label"></pm-label>
    <div>{{Content}}</div>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/field/field.html